(() => {
  if (window.occMinimalLoaded) return;
  window.occMinimalLoaded = true;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const open = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    dialog.ompTrigger = trigger;
    dialog.showModal();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-omp-open],a[href="#occ-delivery"],a[href="#occ-returns"]');
    if (trigger) {
      const id = trigger.dataset.ompOpen || trigger.getAttribute('href').slice(1);
      const dialog = document.getElementById(id);
      if (dialog) { event.preventDefault(); open(dialog, trigger); }
    }
    const close = event.target.closest('[data-omp-close]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('dialog.omp-dialog')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    const feedButton = event.target.closest('[data-omp-feed-next],[data-omp-feed-prev]');
    if (feedButton) {
      const feed = document.getElementById(feedButton.getAttribute('aria-controls'));
      feed?.scrollBy({left:feed.clientWidth * (feedButton.hasAttribute('data-omp-feed-next') ? .8 : -.8),behavior:motion()});
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('dialog.omp-dialog')) event.target.ompTrigger?.focus();
  }, true);

  class MinimalProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      this.gallery = this.querySelector('[data-omp-gallery]');
      this.items = [...this.gallery.querySelectorAll('[data-media-id]')];
      this.groups = JSON.parse(this.querySelector('[data-omp-groups]').textContent);
      this.mediaGroups = JSON.parse(this.querySelector('[data-omp-media-groups]')?.textContent || '{}');
      this.strings = JSON.parse(this.querySelector('[data-omp-strings]').textContent);
      this.purchase = this.querySelector('occ-purchase');
      this.lightbox = this.querySelector('[data-omp-lightbox]');
      this.all = false;
      document.addEventListener('variant:imageChanged', event => {
        if (this.purchase.variants?.some(variant => String(variant.id) === String(event.detail.variantId))) this.selectMedia(event.detail.mediaId);
      }, {signal:this.events.signal});
      this.purchase.addEventListener('change', event => {
        if (!event.target.closest('[data-colour-field]')) return;
        this.selectMedia(this.currentMedia);
        this.revealGallery();
      }, {signal:this.events.signal});
      this.querySelector('[data-omp-all]').addEventListener('click', () => {
        this.all = !this.all;
        this.selectMedia(this.currentMedia);
      });
      this.querySelector('[data-omp-prev]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-omp-next]').addEventListener('click', () => this.step(1));
      this.gallery.addEventListener('scroll', () => this.updateCount(), {passive:true});
      this.gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-omp-zoom]');
        if (!button) return;
        this.largeIndex = this.visibleImages().indexOf(button);
        this.showLarge(); open(this.lightbox,button);
      });
      this.querySelector('[data-omp-lightbox-prev]').addEventListener('click', () => this.largeStep(-1));
      this.querySelector('[data-omp-lightbox-next]').addEventListener('click', () => this.largeStep(1));
      this.lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.largeStep(event.key === 'ArrowRight' ? 1 : -1); }
      });
      this.priceObserver = new MutationObserver(() => this.updateInstalment());
      this.priceObserver.observe(this.purchase.querySelector('[data-price]'),{childList:true,characterData:true,subtree:true});
      this.purchase.form?.addEventListener('change', () => this.updateInstalment());
      this.purchase.previewImage?.();
      if (!this.visible) this.selectMedia(this.items[0]?.dataset.mediaId);
      this.updateInstalment();
    }
    disconnectedCallback() { this.events?.abort(); this.priceObserver?.disconnect(); }
    selectMedia(mediaId) {
      const colourField = this.purchase.querySelector('[data-colour-field]');
      const colour = colourField?.querySelector('input:checked')?.value;
      const changedColour = colour !== this.currentColour;
      if (changedColour) this.all = false;
      this.currentColour = colour;
      const positions = String(this.groups[colour] || '').split(',').map(x => Number(x.trim()));
      const customIds = positions.flatMap(position => this.items.filter(item => Number(item.dataset.position) === position).map(item => item.dataset.mediaId));
      const norm = value => String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
      const altColours = item => { const parts = String(item.dataset.alt || '').split(/\s[–—-]\s/); return parts.length > 1 ? parts[parts.length - 1].split(/\s*[\/,&+]\s*/).map(norm).filter(Boolean) : []; };
      const altIds = colour ? this.items.filter(item => altColours(item).includes(norm(colour))).map(item => item.dataset.mediaId) : [];
      let ids = altIds.length ? altIds : customIds.length ? customIds : (this.mediaGroups[colour] || []);
      const colourIndex = Number(colourField?.dataset.option);
      if (!ids.length && colour && colourField.querySelectorAll('input').length === 1) ids = this.items.map(item => item.dataset.mediaId);
      if (!ids.length && colour && Number.isInteger(colourIndex)) {
        ids = (this.purchase.variants || []).filter(variant => variant.options[colourIndex] === colour && variant.media).map(variant => String(variant.media));
      }
      ids = [...new Set(ids.map(String))].filter(id => this.items.some(item => item.dataset.mediaId === id));
      const grouped = ids.length > 0 && !this.all;
      this.currentMedia = ids.length && !ids.includes(String(mediaId)) ? ids[0] : mediaId;
      this.items.forEach(item => {
        item.hidden = grouped && !ids.includes(item.dataset.mediaId);
        item.style.order = grouped ? ids.indexOf(item.dataset.mediaId) : Number(item.dataset.position);
      });
      this.visible = this.items.filter(item => !item.hidden).sort((a,b) => Number(a.style.order) - Number(b.style.order));
      if (!grouped) {
        const selected = this.items.find(item => String(item.dataset.mediaId) === String(this.currentMedia));
        if (selected) { selected.style.order = '-1'; this.visible = [selected,...this.visible.filter(item => item !== selected)]; }
      }
      if (!grouped && !this.all) {
        this.visible.slice(4).forEach(item => item.hidden = true);
        this.visible = this.visible.slice(0,4);
      }
      this.visible.slice(0,4).forEach(item => item.querySelector('img')?.setAttribute('loading','eager'));
      const allButton = this.querySelector('[data-omp-all]');
      allButton.hidden = ids.length ? ids.length === this.items.length : this.items.length <= 4;
      allButton.textContent = this.all ? (ids.length ? this.strings.colour : this.strings.fewer) : this.strings.all;
      this.gallery.scrollLeft = 0;
      this.index = 0;
      this.updateCount();
      if (this.lightbox.open) { this.largeIndex = 0; this.showLarge(); }
    }
    revealGallery() {
      // Mobile: the colour swatches sit below the photos, so bring the photos back into view.
      if (!matchMedia('(max-width: 800px)').matches) return;
      const header = document.querySelector('.section-header, sticky-header, .header-wrapper');
      const offset = header && getComputedStyle(header).position.match(/sticky|fixed/) ? header.getBoundingClientRect().height : 0;
      const top = this.gallery.getBoundingClientRect().top + window.scrollY - offset - 12;
      if (Math.abs(window.scrollY - top) > 40) window.scrollTo({ top, behavior: motion() });
    }
    updateCount() {
      if (!this.visible?.length) return;
      const left = this.gallery.getBoundingClientRect().left;
      this.index = this.visible.reduce((best,item,i)=>Math.abs(item.getBoundingClientRect().left-left)<Math.abs(this.visible[best].getBoundingClientRect().left-left)?i:best,0);
      this.querySelector('[data-omp-count]').textContent = `${this.index + 1} / ${this.visible.length}`;
    }
    step(delta) {
      const index = Math.max(0,Math.min(this.visible.length-1,(this.index || 0)+delta));
      const target = this.visible[index];
      if (target) this.gallery.scrollTo({left:target.offsetLeft-this.gallery.offsetLeft-20,behavior:motion()});
    }
    visibleImages() { return (this.visible || []).flatMap(item=>[...item.querySelectorAll('[data-omp-zoom]')]); }
    showLarge() {
      const buttons = this.visibleImages(), button = buttons[this.largeIndex];
      if (!button) return;
      const image = this.querySelector('[data-omp-large]');
      image.src = button.dataset.src; image.alt = button.querySelector('img').alt;
      this.querySelector('[data-omp-large-count]').textContent = `${this.largeIndex + 1} / ${buttons.length}`;
    }
    largeStep(delta) { const length = this.visibleImages().length; if (!length) return; this.largeIndex=(this.largeIndex+delta+length)%length; this.showLarge(); }
    updateInstalment() {
      const node=this.querySelector('[data-omp-instalment]');
      if (!node) return;
      const price=this.purchase.selected?.price ?? this.purchase.variants?.[0]?.price;
      if (typeof price==='number') node.textContent=new Intl.NumberFormat('en-ZA',{style:'currency',currency:this.purchase.dataset.currency}).format(price/600);
    }
  }
  customElements.define('occ-minimal-product',MinimalProduct);

  class MinimalRelated extends HTMLElement {
    connectedCallback() {
      if (this.started || this.hasAttribute('data-curated')) return;
      this.started=true;
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry=>entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
      },{rootMargin:'600px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect();this.request?.abort(); }
    async load() {
      this.request=new AbortController();
      const timeout=setTimeout(()=>this.request.abort(),8000);
      try {
        const url=new URL(this.dataset.url,location.origin);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');
        if(preview)url.searchParams.set('preview_theme_id',preview);
        const response=await fetch(url,{signal:this.request.signal});
        if(!response.ok)return;
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const grid=doc.querySelector('[data-omp-related-grid]');
        if(grid?.children.length && this.isConnected)this.querySelector('[data-omp-related-grid]').replaceChildren(...grid.children);
      } catch (_) {} finally {clearTimeout(timeout);}
    }
  }
  customElements.define('occ-minimal-related',MinimalRelated);
})();
